import { useRouter } from "next/router"
import { useRecoilValue } from "recoil"
import styled from "styled-components"

import { selectProgressStepV2 } from "stores/progress"
import Card from "components/atoms/card"
import ProgressBarV3 from "components/organisms/progress-bar-v3"
import { COLOR, SHADOW_LV1 } from "styles/style-constants"

const Wrapper = styled.div`
  padding-left: 56px;
  padding-right: 56px;
  padding-bottom: 30px;
  height: 100%;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;

  .screeningOptionNextBtn,
  .important-text {
    display: none;
  }

  .screeningOptionNextBtnSet {
    display: flex;
  }

  @media (max-width: 520px) {
    margin: 0px;
    height: unset;
    padding: 0 16px 19px 16px;

    .screeningOptionNextBtn {
      display: flex;
      margin-top: 32px;
    }

    .important-text {
      display: flex;
    }

    .screeningOptionNextBtnSet {
      display: none;
    }
  }
`

const ScreeningStepV2 = ({ children, ...rest }) => {
  const progressStep = useRecoilValue(selectProgressStepV2)
  const router = useRouter()
  const { partner } = router.query

  return (
    <Card
      width="760px"
      height="586px"
      MaxHeight="760px"
      mWidth="100%"
      mMaxWidth="100%"
      mHeight="100vh"
      mMaxHeight="none"
      mBorder="none"
      mNoShadow
      radius="16px"
      border={`1px solid ${COLOR.deepBluePale}`}
      boxShadow={SHADOW_LV1}
      mUnsetHeight
    >
      <ProgressBarV3 steps={progressStep} />
      <Wrapper>
        {children}
      </Wrapper>
    </Card>
  )
}

export default ScreeningStepV2
